<div class="row principalDarkerBackground centrado fullHeight">
    <div class="card width90 ">
        <div class="container">

            <div class="row centrado">
                <div class="col-md-12">
                    <img src="assets/images/logo.png" class="imgLogoXS">
                </div>
                <!-- para desktop -->

                <div *ngIf="deviceChecked.isDesktop || uploadFile || isiOS">
<
                    <div class="col-md-12 centrado ">
                        <app-camera [model]="frontPicture" [defaultBackground]="'assets/images/card1.png'" [horizontalOnly] = true
                                    [title]="'FRONTAL'" (takePicture)="takePictureFront($event)" [isDesktop] =  isDesktopDevice
                        ></app-camera>
                    </div>
                    <div class="col-md-12 centrado">
                        <app-camera [model]="backPicture" [defaultBackground]="'assets/images/card2.png'" [horizontalOnly] = true
                                    [title]="'POSTERIOR'" (takePicture)="takePictureBack($event)" [isDesktop] =  isDesktopDevice></app-camera>
                    </div>
                    <br>

                </div>


                <!-- para mobile preguntas-->

                <div *ngIf="deviceChecked.isMobile && !isiOS">
                    <div class = "row centrado container" *ngIf="showOptions">
                        <div class="row">
                            <p class="colorSecundario  fontItalic">  <br> Seleccione la manera de subir su DNI
                                <br></p>
                        </div>
                        <div class="row">
                            <br>
                            <div class="col-6">
                                <a class="nav-link botonID principalBackground " (click)="checkOption('cam')">
                                    <i class="fas fa-camera  fa-2x padding10 "></i></a>
                                <span class="colorSecundario  fontItalic"> Tomar Foto</span>
                            </div>

                            <div class="col-6">
                                <a class="nav-link botonID principalBackground " (click)="checkOption('upl')">
                                    <i class="fas fa-upload  fa-2x padding10"></i></a>
                                <span class="colorSecundario  fontItalic"> Desde Galería</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- para mobile: cámara -->
                <div *ngIf="takePic">
                    <div class="col-md-12">
                        <br>
                        <p class="colorSecundario  fontItalic"> *Pulsa sobre los iconos para capturar la foto de tu DNI
                            <br>
                            * Pulsa sobre las capturas para repetirlas</p>
                    </div>

                    <div class="row centrado ">
                        <div class="col-md-12 centrado ">
                            <idnow-camera-embed [model]="frontPicture" [defaultBackground]="'assets/images/card1.png'"
                                                [overlay]="'assets/images/id_front_bttn@2x.png'" [horizontalOnly] = true
                                                [title]="'FRONTAL'" (takePicture)="takePictureFront($event)"
                                                *ngIf="isNotSafari"></idnow-camera-embed>
                        </div>
                        <div class="col-md-12 centrado">
                            <idnow-camera-embed [model]="backPicture" [defaultBackground]="'assets/images/card2.png'"
                                                [overlay]="'assets/images/id_back_bttn@2x.png'" [horizontalOnly] = true
                                                [title]="'POSTERIOR'" (takePicture)="takePictureBack($event)"
                                                *ngIf="isNotSafari"></idnow-camera-embed>
                        </div>
                    </div>


                </div>
                <div class="col-md-12 centrado"  *ngIf="!showOptions || deviceChecked.isDesktop || isiOS">
                    <div class="col-md-4"></div>
                    <div class="col-md-3">
                        <a class="nav-link botonID principalBackground rightHelp" (click)="sendID()">
                            ENVIAR  </a>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </div>
    </div>
</div>
